import { z } from "zod";

/** AppSync Events namespace and channel (SPEC §9). */
export const EVENT_NAMESPACE = "game";
export const gameChannel = (code: string) => `/${EVENT_NAMESPACE}/${code}`;

const base = { version: z.number().int().nonnegative() };

/** Realtime events are signals only; clients refetch GET /games/{code} when `version` grows. */
export const gameEventSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("player_joined"), ...base, playerCount: z.number().int() }),
  z.object({ type: z.literal("player_removed"), ...base, playerId: z.string() }),
  z.object({ type: z.literal("game_started"), ...base }),
  z.object({ type: z.literal("round_opened"), ...base, roundNo: z.number().int() }),
  z.object({
    type: z.literal("answer_progress"),
    ...base,
    roundNo: z.number().int(),
    answered: z.number().int(),
    expected: z.number().int(),
  }),
  z.object({ type: z.literal("round_resolved"), ...base, roundNo: z.number().int() }),
  z.object({ type: z.literal("game_finished"), ...base }),
]);

export type GameEvent = z.infer<typeof gameEventSchema>;
export type GameEventType = GameEvent["type"];
